import { useForm } from 'react-hook-form';
import { Link } from "react-router-dom";
// import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import InputEmail from './InputEmail';
import InputPassword from './InputPassword';
import SubmitButton from '../../../components/buttons/SubmitButton';
import { useTranslation } from 'react-i18next';
import { useLangUrl } from '../../../utilities/useLangUrl';

export default function LoginForm({ setLoading, setErrorMessage, errorMessage }) {
    const { register, handleSubmit, formState: { errors } } = useForm();
    // const navigate = useNavigate();
    const { t } = useTranslation();
    const langUrl = useLangUrl();

    async function onSubmit(data) {
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_MASAR_API_URL}/auth/login`, {
                method: "POST",
                headers: {
                    "accept": "*/*",
                    "Content-Type": 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (response.status === 401 || response.status === 400) {
                setErrorMessage(t("errorLogin"))
                return;
            }

            const responseData = await response.json();
            const token = responseData.data.accessToken;

            // Save token to localStorage
            Cookies.set('token', token, { expires: 7, secure: true });
            window.location.reload();

            // Redirect to another page after successful login
            // navigate('/');
        }
        catch (error) {
            console.error("An error occurred during login", error);
            setErrorMessage(t("errorTryAgain"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className='d-flex flex-column mx-auto mt-4 mb-1 gap-3' onSubmit={handleSubmit(onSubmit)}>
            <InputEmail
                register={register}
                errors={errors}
            />

            <InputPassword
                register={register}
                errorMessage={errorMessage}
            />

            <Link className='text-white'
                to={`${langUrl}/resetPassword`}
            >{t("forgetPW")}</Link>

            <p>{t("NoAccount")}
                <br />
                <Link className='text-white text-decoration-none' to={`${langUrl}/Register`}>{t("register")}</Link>
            </p>
            <SubmitButton
                value={t("Enter")}
                type="submit"
            />


        </form>
    )
}
